export default {
  goodDeals: {
    id: 'menu_good_deals',
    defaultMessage: 'Good deals',
  },
  blackFriday: {
    id: 'menu_black_friday',
    defaultMessage: 'Black Friday',
  },
  holidays: {
    id: 'menu_holidays',
    defaultMessage: 'Holidays',
  },
}
